import apiClient from 'services/_infra/apiClient';

export async function getServices() {
  try {
    const res = await apiClient.get('/service-manager/supervisor/services');
    console.log('Services:', res);
    return res.data;
  } catch (err) {
    console.error('Error fetching services:', err);
    throw err;
  }
}
